var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.copyable
    ? _c(
        "button",
        {
          staticClass: "vds-copyable vds-copyable--btn",
          class: {
            "vds-copyable--icon-start": _vm.iconStart
          },
          attrs: {
            type: "button",
            "aria-label": "Copy ".concat(_vm.value)
          },
          on: {
            click: _vm.copy
          }
        },
        [
          _vm.iconStart
            ? _c(
                "v-icon",
                {
                  staticClass: "vds-copyable__icon mr-1",
                  attrs: {
                    "x-small": "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-content-copy")]
              )
            : _vm._e(),
          _c(
            "span",
            {
              staticClass: "vds-copyable__text"
            },
            [_vm._v(_vm._s(_vm.display || _vm.value))]
          ),
          !_vm.iconStart
            ? _c(
                "v-icon",
                {
                  staticClass: "vds-copyable__icon ml-1",
                  attrs: {
                    "x-small": "",
                    "aria-hidden": "true"
                  }
                },
                [_vm._v("mdi-content-copy")]
              )
            : _vm._e()
        ],
        1
      )
    : _c(
        "span",
        {
          staticClass: "vds-copyable vds-copyable--static"
        },
        [_vm._v(_vm._s(_vm.display || _vm.value))]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }